import PageTransition from "../components/v2/PageTransition";
import Wordmark from "../components/v2/Wordmark";
import "../components/v2/v2-question-surface.css";

export default function IntroducerSavingSurface({ recipientName, theme }) {
  const isClean = theme === "clean";

  return (
    <section
      className="tgc-v2-surface tgc-v2-surface--saving"
      aria-labelledby="introducer-saving-heading"
      aria-live="polite"
      aria-busy="true"
    >
      <PageTransition>
        <div className="tgc-v2-saving-shell" role="status">
          <Wordmark variant="stacked" />
          <div className="tgc-v2-saving-path" aria-hidden="true">
            <span className="tgc-v2-saving-path__light" />
          </div>
          <h1 className="tgc-v2-saving-heading" id="introducer-saving-heading">
            {isClean ? "Almost done." : "You just did something really kind."}
          </h1>
          <p className="tgc-v2-saving-body">
            {isClean
              ? `Saving ${recipientName || "their"}'s gift now.`
              : `Wrapping everything up for ${recipientName || "them"}…`}
          </p>
          <p className="tgc-v2-saving-note">Just a moment</p>
        </div>
      </PageTransition>
    </section>
  );
}
